import React from 'react';
import {
  Box,
  Button,
  ImageList,
  ImageListItem,
  Modal,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: 4,
};

const ImageUploadModal = ({ open, images, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Review your images before submission:
        </Typography>
        <Box sx={{ maxHeight: '60vh', overflowY: 'auto', marginTop: 3 }}>
          <ImageList variant="masonry" cols={3}>
            {images.map((file, index) => (
              <ImageListItem key={index}>
                <img
                  src={URL.createObjectURL(file)}
                  alt={`preview ${index}`}
                  loading="lazy"
                  style={{ width: '100%', height: '100%' }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button color="error" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Confirm Upload
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

ImageUploadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  images: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ImageUploadModal;
